<template>
  <div>
    <div
      id="add-on"
      class="section haze full-height"
    >
      <div class="wrapper w-container">
        <div class="middle">
          <h5 class="green left">
            <strong>Step 2 of 3 | </strong><span><strong class="bold-text-2">Plan Selection</strong></span>
          </h5>
        </div>
      </div>
      <div class="wrapper checkout-container w-container">
        <div class="intro">
          <div class="text-label-2 less-margin-bottom">
            Don&#x27;t forget the add-ons
          </div>
          <div class="plan-selected w-clearfix">
            <img
              src="signUp/images/check-circle-color.svg"
              alt=""
              class="button-icon bigger"
            >
            <h4 class="add-ons-subtext">
              <strong>{{ currentPatient.plan.display_name }}</strong> <span class="text-span-2">${{ currentPatient.plan.base_price | toMonetary }}/Month</span>
            </h4>
          </div>
          <h2 class="volk">
            Select New Add Ons for {{ currentPatient.first_name }}
          </h2>
          <div class="divider-2 animated" />
        </div>
        <div class="wrapper">
          <div class="w-layout-grid main-grid-flex">
            <addon-component
              v-for="(addon, index) in addons"
              :key="addon.id"
              :css-class="getCssClassByIndex(index)"
              :addon="addon"
              :company="company"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-w-id="b9b28d86-0c47-021d-c8ea-52fdf66e1773"
      role="banner"
      class="footer-bar w-nav"
    >
      <div class="wrapper nav-bar-wrapper">
        <div class="footer-columns">
          <a
            id="w-node-52fdf66e1776-5ade2a58"
            href="signup-edit-details-1.html"
            class="button bigger w-inline-block w-clearfix"
          ><img
             src="signUp/images/left-white.svg"
             alt=""
             class="button-icon bigger"
           >
            <div class="text-left bigger">Previous</div>
          </a>
          <a
            id="w-node-52fdf66e177a-5ade2a58"
            href="signup-2-6.html"
            class="button bigger w-inline-block w-clearfix"
          >
            <div class="text-left bigger">Next</div><img
              src="signUp/images/right-white_1.svg"
              alt=""
              class="button-icon bigger"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddonComponent from '../signup/SignupAddonComponent'
import Util from '../../helpers/Util'
import _ from 'lodash'

export default {
  name: 'Signup3Component',
  components: {
    'addon-component': AddonComponent
  },
  filters: {
    toMonetary: function (value) {
      return Util.ConvertRealToMonetaryZero(value)
    },
    toRewards: function (plan) {
      return (plan.rewards * (12 / plan.frequency)).toFixed(0)
    }
  },
  props: {
    currentPatient: {
      type: Object,
      default: null,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    addons: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      selected: false
    }
  },
  computed: {
  },
  mounted () {
    console.log(this)
    window.Webflow && window.Webflow.destroy()
    window.Webflow && window.Webflow.ready()
    window.Webflow && window.Webflow.require('ix2').init()
    document.dispatchEvent(new Event('readystatechange'))
    //set next to auto true if all addons have 0 price
    this.next = true
    this.$parent.addons.forEach(function(value, index, array) 
      {
        if (value.base_price > 0) {
          this.next = false
        }
      }
    )
    if (this.next) {
        this.$parent.next()
    }
  },
  methods: {
    getCssClassByIndex (idx) {
      if (idx === 1) {
        return 'feature left add-ons mint-addon'
      } else if (idx === 2) {
        return 'feature left add-ons blue-addon'
      } else if (idx === 3) {
        return 'feature left add-ons slate-addon'
      } else {
        return 'feature left add-ons gold-addon'
      }
    },
    getCssStyleAddonSelected () {
      return '0 0 0 10px #ee645a'
    }
  }
}
</script>
